import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { BaseComponent } from "@common/ux/base.component/base.component";
import { CommonIntegratedArchitectureFrameworkAuthService } from "@org-common/lib/architecture/common-integrated-architecture-framework-auth.service";
import { OrganisationMapSupplementaryData } from "@org-common/lib/architecture/organisation-map/organisation-map-supplementary-data.enum";
import { AuthorisationService } from "@org-common/lib/authorisation/authorisation.service";
import { DefaultOrganisationMapFilter, IOrganisationMapFilterParams, OrganisationMapFilterParamKeys, OrganisationMapFilterService } from "./organisation-map-filter.service";

@Component({
    selector: "adapt-organisation-map-filter",
    standalone: false,
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: "./organisation-map-filter.component.html",
})
export class OrganisationMapFilterComponent extends BaseComponent implements OnInit {
    public readonly OrganisationMapFilterParamKeys = OrganisationMapFilterParamKeys;

    public supplementaryDataOptions = [
        { value: OrganisationMapSupplementaryData.TeamMembers, text: "Team members" },
        { value: OrganisationMapSupplementaryData.Accountabilities, text: "Accountabilities" },
        { value: OrganisationMapSupplementaryData.Roles, text: "Roles" },
    ];
    private readonly systemSupplementaryDataOption = { value: OrganisationMapSupplementaryData.Systems, text: "Systems" };

    @Input() public disabled = false;
    @Output() public filterChanged = new EventEmitter<IOrganisationMapFilterParams>();

    @Input() public tooltipContent?: string;

    @Input() public isDefaultOverride?: boolean;

    public currentFilter: IOrganisationMapFilterParams = { ...DefaultOrganisationMapFilter };
    public isDefaultFilter = true;
    private isDefaultFilterUpdater = this.createThrottledUpdater((isDefault: boolean) => this.isDefaultFilter = isDefault);

    public constructor(
        private organisationMapFilterService: OrganisationMapFilterService,
        private authService: AuthorisationService,
    ) {
        super();

        this.currentFilter = { ...organisationMapFilterService.filter$.value };
    }

    public async ngOnInit() {
        const hasReadSystem = await this.authService.promiseToGetHasAccess(CommonIntegratedArchitectureFrameworkAuthService.ReadSystem);
        if (hasReadSystem) {
            this.supplementaryDataOptions.push(this.systemSupplementaryDataOption);
        }

        this.organisationMapFilterService.filter$.pipe(
            this.takeUntilDestroyed(),
        ).subscribe((filter) => {
            this.currentFilter = { ...filter };
            this.isDefaultFilterUpdater.next(this.organisationMapFilterService.isDefault);
            this.filterChanged.emit(this.currentFilter);
        });
    }

    public async emitFilterChanged() {
        await this.organisationMapFilterService.updateFilter(this.currentFilter);
    }

    public resetOptions() {
        this.organisationMapFilterService.reset();
    }
}
